.button-container {
    display: flex;
    min-width: fit-content;
}

.button-container button {
    padding: 0;
}
